import { render, staticRenderFns } from "./LogoTitle.vue?vue&type=template&id=b9548e6c&scoped=true"
import script from "./LogoTitle.vue?vue&type=script&lang=ts"
export * from "./LogoTitle.vue?vue&type=script&lang=ts"
import style0 from "./LogoTitle.vue?vue&type=style&index=0&id=b9548e6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9548e6c",
  null
  
)

export default component.exports